var _path, _path2, _path3;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEventreport(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4714 9.13809C10.7318 8.87774 10.7318 8.45563 10.4714 8.19528C10.2111 7.93493 9.78895 7.93493 9.5286 8.19528L10.4714 9.13809ZM7.33333 11.3334L6.86193 11.8048C7.12228 12.0651 7.54439 12.0651 7.80474 11.8048L7.33333 11.3334ZM6.4714 9.52862C6.21105 9.26827 5.78895 9.26827 5.5286 9.52862C5.26825 9.78897 5.26825 10.2111 5.5286 10.4714L6.4714 9.52862ZM9.5286 8.19528L6.86193 10.8619L7.80474 11.8048L10.4714 9.13809L9.5286 8.19528ZM7.80474 10.8619L6.4714 9.52862L5.5286 10.4714L6.86193 11.8048L7.80474 10.8619Z",
    fill: "#57606A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9997 14H3.99968C3.63149 14 3.33301 13.7015 3.33301 13.3333L3.33301 2.66667C3.33301 2.29848 3.63148 2 3.99967 2L9.04173 2C9.22744 2 9.40473 2.07746 9.53091 2.21373L12.4888 5.40831C12.603 5.53154 12.6663 5.6933 12.6663 5.86125L12.6663 13.3333C12.6663 13.7015 12.3679 14 11.9997 14Z",
    stroke: "#57606A",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.667 6L9.33366 6C8.96547 6 8.66699 5.70152 8.66699 5.33333L8.66699 2",
    stroke: "#57606A",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventreport);
export default __webpack_public_path__ + "static/media/event report.cfb86e24d58f497c3fe14e80d491a20a.svg";
export { ForwardRef as ReactComponent };